import React, { FC, useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'

import { useAuth } from 'core/auth'
import { useUpload } from 'core/upload/api'
import { useShowMessage, useApiError } from 'shared/hooks'

import { Spin, Upload, Input } from 'antd'
import { BackIcon, PageContainer } from 'components'

import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface'

import add from './assets/add.png'

export const MultipleNFT: FC = () => {
    const navigate = useNavigate()
    const {
        methods: { error, success }
    } = useShowMessage()
    const {
        methods: { handleError }
    } = useApiError('SingleNft', error as any)
    const {
        loading,
        methods: { uploadZip }
    } = useUpload()
    const { account } = useAuth()

    const [fileList, setFileList] = useState<UploadFile[]>([])
    const [tags, setTags] = useState('')

    const props: UploadProps = {
        listType: 'picture-card',
        className: 'upload-style',
        accept: '.zip',
        showUploadList: {
            showRemoveIcon: true,
            showPreviewIcon: false
        },
        onRemove: file => {
            const index = fileList.indexOf(file)
            const newFileList = fileList.slice()
            newFileList.splice(index, 1)
            setFileList(newFileList)
        },
        beforeUpload: file => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = e => {
                ;(file as any).thumbUrl = e.target?.result
                setFileList([...fileList, file])
            }

            return false
        },
        fileList
    }

    const handleSubmit = useCallback(() => {
        if (!account) return
        if (fileList.length <= 0 || !tags) {
            error('Please improve the information and submit')
            return
        }
        const formData = new FormData()
        formData.append('zip_file', fileList[0] as RcFile)
        formData.append('account', account)
        formData.append('tags', tags)
        uploadZip(formData as any)
            .then(() => {
                setFileList([])
                setTags('')
                success('Upload successfully')
            })
            .catch(err => {
                handleError('Upload failure')
            })
    }, [account, error, fileList, handleError, success, tags, uploadZip])

    return (
        <Spin spinning={loading}>
            <Container>
                <div className="flex items-center">
                    <BackIcon onClick={() => navigate(-1)} />
                    <div className="title">Zipped Media File</div>
                </div>
                <div className="item">
                    <div className="label">
                        <div>.Zip file only</div>
                    </div>
                    <Upload {...props}>
                        {fileList.length < 1 && (
                            <div className="uploadBtn">
                                <img src={add} alt="" />
                            </div>
                        )}
                    </Upload>
                </div>
                <div className="item">
                    <div className="label">
                        <div>Tag</div>
                    </div>
                    <Input
                        style={{ width: '100%', height: '40px' }}
                        value={tags}
                        onChange={e => setTags(e.target.value)}
                        placeholder={'separate tag with comma'}
                    />
                </div>
                <div className="btn" onClick={handleSubmit}>
                    Submit
                </div>
            </Container>
        </Spin>
    )
}

const Container = styled(PageContainer)`
    width: 580px;
    padding: 0;
    padding-bottom: 80px;
    .title {
        margin-left: 14px;
        width: 100%;
        height: 128px;
        line-height: 128px;
        font-family: Roboto-Medium;
        font-size: 36px;
        color: #000000;
        letter-spacing: 0;
    }
    .item {
        margin-bottom: 30px;
        .label {
            margin-bottom: 10px;
            font-family: HelveticaNeue-Medium;
            font-size: 18px;
            color: #000000;
            line-height: 26px;
        }
        .tip {
            font-family: Roboto-Regular;
            font-size: 12px;
            color: #000000;
        }
    }
    .uploadBtn {
        img {
            width: 50px;
            height: 50px;
        }
    }
    .ant-input {
        font-family: Roboto-Regular;
        font-size: 18px;
        &::placeholder {
            font-family: Roboto-Regular;
            font-size: 16px;
            color: #c2c2c2;
        }
    }
    .upload-style {
        .ant-upload-list-picture-card-container {
            width: 320px;
            height: 180px;
        }
        .ant-upload.ant-upload-select-picture-card {
            background-color: #ffffff;
        }
        .ant-upload {
            width: 320px;
            height: 180px;
        }
    }
    .btn {
        width: 100%;
        height: 50px;
        font-family: Roboto-Medium;
        font-size: 25.33px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: 50px;
        background: #000000;
        border-radius: 35.18px;
        cursor: pointer;
    }
    @media (max-width: 768px) {
        padding: 0 20px 40px 20px;
        width: 100%;
    }
`
